import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import styles from './header.module.scss';
import logo from '../../../../public/images/logo-black.svg'
import SoundIcon from '../../icons/soundIcon';
import Link from 'next/link';
import Nav from '../nav/nav';
import { gsap } from 'gsap/dist/gsap';
import playClick from '../../actions/default-click';
import playHover from '../../actions/default-hover';
import ArrowButton from '../../arrowButton';
import menuBg from '../../../../public/images/credit-bg.jpg';
import { useRouter } from 'next/router';

function Header({music, setHide, music2}) {
  // Get the background music
  const backAudio = localStorage.getItem("backgroundMusic");
  function isMusicPlaying(audelem) { return !audelem?.paused; }
  // Use Router
  const router = useRouter();
  // Update Music
  const [isPlaying, setIsPlaying] = useState(backAudio === "playing" ? true : false);
  const [openMenu, setOpenMenu] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  // Get Page name
  var locs = router.asPath.replace(/\.\w+$/, '').split('/');

  useEffect(() => {
    // Player on change
    if(isPlaying) {
      //console.log(locs[locs.length - 2]);
      if(locs[locs.length - 2] !== 'room2' && locs[locs.length - 2] !== 'room3' && locs[locs.length - 2] !== 'hidden-secret' && locs[locs.length - 2] !== 'monastery' && locs[locs.length - 2] !== 'fake-identity' && locs[locs.length - 2] !== 'children' && router.asPath !== '/story/room2/result/' && router.asPath !== '/story/room3/result/') {
        // Music 2
        if(isMusicPlaying(music2) && music2) {
          gsap.to(music2, {volume: 0, duration: 1.5, onComplete: () => {
            music2.pause();
          }});
        }
        //console.log(locs[locs.length - 2] !== 'room2');
        if(!isMusicPlaying(music) && music) {
          music.play();
          // Toggle volume
          gsap.to(music, {volume: 1, duration: 2});
        }
      } else {
        // Music 1
        gsap.to(music, {volume: 0, duration: 1.5, onComplete: () => {
          music.pause();
        }});
        // Music 2
        if(!isMusicPlaying(music2) && music2) {
          music2.play();
          // Toggle volume
          gsap.to(music2, {volume: 1, duration: 2});
        }
      }

      localStorage.setItem("backgroundMusic", "playing");
    } else {
      // Toggle volume
      gsap.to(music, {volume: 0, duration: 1.5, onComplete: () => {
        music.pause();
      }});
      if(isMusicPlaying(music2) && music2) {
        gsap.to(music2, {volume: 0, duration: 1.5, onComplete: () => {
          music2.pause();
        }});
      }
      localStorage.setItem("backgroundMusic", "pause");
    }

  }, [isPlaying, locs, music, music2, router.asPath])

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  }

  useEffect(() => {
    if(!setHide) {
      gsap.set('#header', {xPercent: 100, opacity: 0}); 
      gsap.to('#header', {xPercent:0, opacity: 1, ease:"ease.in", duration: 1})
    } else {
      gsap.set('#header', {xPercent: 100, opacity: 0});
    }
  }, [setHide])

  return (
    <header 
    id={'header'}
    className={`${styles.header} fixed h-screen top-0 right-0 bg-white z-50 p-5 flex flex-wrap items-center justify-center`}>
      <div className={`${styles.headerTop} music mb-auto flex flex-wrap items-center justify-center`}>
        <button 
        onClick={() => {
          setOpenMenu(!openMenu);
          playClick();
        }}
        onMouseEnter={() => playHover()}>
          <p>{openMenu ? 'סגירה' : 'תפריט'}</p>
        </button>
        <button 
        onClick={(e) => {
          handlePlayPause();
          setDisableButton(true);
          setTimeout(() => {
            setDisableButton(false);
          }, 2000 );
          playClick();
        }}
        onMouseEnter={() => playHover()}
        disabled={disableButton}
        className={`${styles.sound} relative flex justify-center items-center rounded-full`}>
          <SoundIcon data={isPlaying} />
          <span className='rounded-full'></span>
        </button>
      </div>

      <div className={`${styles.pagination} navigation`}>
        <Nav />
      </div>

      <div className={`${styles.logo} logo mt-auto`}>
        <Link href={'/'}>
         <a>
          <Image 
          width={logo.width}
          height={logo.height}
          src={logo.src} alt={'Logo'} />
         </a>
        </Link>
      </div>

      <div className={`fixed top-0 right-full flex justify-center ${openMenu && styles.menuOpen} ${styles.fullMenu}`}>
       <div className={`absolute top-0 right-0 z-10 w-full h-full ${styles.overlay}`}>
          <Image
          className={'w-full h-full object-cover object-center'}
          width={menuBg?.width}
          height={menuBg?.height}
          src={menuBg?.src}
          blurDataURL={menuBg?.blurDataURL}
          placeholder={'blur'}
          alt={menuBg?.alt}
          />
        </div>
        
        <div className={`z-50 relative text-center ${styles.menuWrapper}`}>
            <div className={styles.menuTitle}>
              <h2>במסתרים</h2>
              <p>סיפורם של ילדי מסתור בתקופת השואה</p>
            </div>
            <div className={`${styles.menuSet} ${styles.menuSet1}`}>
              <div className={styles.menuLink}>
                <Link href={'/'}>
                  <a>להתחיל מהתחלה</a>
                </Link>
              </div>
              <div className={styles.menuLink}>
                <Link href={'/story/'}>
                  <a>בחירת פרקים</a>
                </Link>
              </div>
              <div className={styles.menuLink}>
                <Link href={'/'}>
                  <a>לסיפור של שרה ורות</a>
                </Link>
              </div>
            </div>
            <div className={`flex justify-center ${styles.divider}`}></div>
            <div className={`${styles.menuSet} ${styles.menuSet2}`}>
              <div className={styles.menuLink}>
                <Link href={'/about/'}>
                  <a>אודות</a>
                </Link>
              </div>
              <div className={styles.menuLink}>
                <Link href={'/about/parents-and-teachers/'}>
                  <a>להורים ומורים</a>
                </Link>
              </div>
              <div className={styles.menuLink}>
                <Link href={'/story/end/credit/'}>
                  <a>קרדיטים</a>
                </Link>
              </div>
              <div className={styles.menuLink}>
                <Link href={'https://docs.google.com/forms/d/e/1FAIpQLSczVfdPYvpmGbp09MdyLI7odzhAFUC1cTRxj-bOWOpBOX-IEw/viewform'}>
                  <a target={'_blank'}>משוב</a>
                </Link>
              </div>
            </div>
        </div>
        <div className={`absolute direction-rtl z-50 ${styles.button}`}>
            <ArrowButton 
              onClick={() => {
                playClick();
              }}
              onMouseEnter={() => {
                playHover();
              }}
              className='p-5'
              link='https://www.ganzach.org.il/' 
              openIn={'_blank'}
              color={'#223A57'} 
              textColor={'#223A57'} 
              text={'לאתר גנזך קידוש השם'}
              />
        </div>
      </div>
    </header>
  )
}

export default Header